import styled from 'styled-components';

export const EmptyListStyled = styled.p`
  margin: 30px auto;
  text-align: center;
  width: 75%;
`